import { useLanguage, useTranslation } from '@ice-web-app/shared-hooks';
import { Grid, Stack } from '@mui/material';
import { useState } from 'react';
import { DsButton } from '../../../../components/buttons/DsButton';
import { DsIcon } from '../../../../components/icons/DsIcon';
import { DsModal } from '../../../../components/modal/DsModal';
import { DsTypography } from '../../../../components/typography/DsTypography';

const ModalContent = ({ onClose }: { onClose: () => void }) => {
  const { userLanguages, changeLanguage } = useLanguage();
  const [loading, setLoading] = useState<string>();

  const handleChangeLanguage = async (languageCode: string) => {
    setLoading(languageCode);
    try {
      await changeLanguage(languageCode);
      onClose();
    } finally {
      setLoading(undefined);
    }
  };

  return (
    <Grid container>
      {userLanguages?.map((language) => (
        <Grid item xs={4} key={language.name}>
          <DsButton onClick={() => handleChangeLanguage(language.name)} loading={loading === language.name} fullWidth>
            <Stack direction="row" gap={4} alignItems="center">
              <DsIcon icon="WEBSITE" />
              <DsTypography variant="body2_500" color="iceGray.700" lineClamp="1">
                {language.displayName}
              </DsTypography>
            </Stack>
          </DsButton>
        </Grid>
      ))}
    </Grid>
  );
};

export const ChangeLanguageModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { t } = useTranslation();

  return (
    <DsModal
      size="xs"
      content={<ModalContent onClose={onClose} />}
      open={open}
      onClose={onClose}
      header={t('CHANGE_LABEL', { label: t('LANGUAGE') })}
    />
  );
};
